import React, { useState, useEffect } from "react";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import { InputGroup } from "react-bootstrap";
import { BsEye, BsEyeSlash, BsChevronDown, BsChevronRight } from "react-icons/bs";
import { ApiUrl } from "../../../ApiUrl";


const moduleHierarchy = [
  { parent: "dashboard", label: "Dashboard", children: [
    { code: "dashboard.fee_dashboard", label: "Fee Dashboard" },
    { code: "dashboard.attendance", label: "Attendance Dashboard" },
    { code: "dashboard.trustee_dashboard", label: "Trustee Dashboard" },
    { code: "dashboard.principal_dashboard", label: "Principal Dashboard" },
    { code: "dashboard.superadmin_dashboard", label: "Super Admin Dashboard" },
    { code: "dashboard.Register_dashboard", label: "Register Dashboard" },
    { code: "dashboard.accountant_dashboard", label: "Accountant Dashboard" },
    { code: "dashboard.hr_dashboard", label: "HR Dashboard" },
    { code: "dashboard.exam_dashboard", label: "Exam Dashboard" },
    { code: "dashboard.teacher_dashboard", label: "Teacher Dashboard" },
    { code: "dashboard.student_dashboard", label: "Student Dashboard" },
    { code: "dashboard.parent_dashboard", label: "Parent Dashboard" },
    { code: "dashboard.tp_dashboard", label: "Training & Placement Dashboard" },
  ]},
  { parent: "student", label: "Student", children: [
    { code: "student.registration", label: "Registration" },
    { code: "student.attendance", label: "Attendance" },
    { code: "student.assignment", label: "Assignment" },
    { code: "student.promotion", label: "Promotion" },
    { code: "student.class", label: "Student Course" },
    { code: "student.confirm", label: "Student Confirm" },
    { code: "student.certificate", label: "Student Certificate" },
    { code: "student.message", label: "Student Message" },
    { code: "student.club", label: "Student Club" },
    { code: "student.circular", label: "Circulars" },
  ]},
  { parent: "staff", label: "Staff", children: [
    { code: "staff.registration", label: "Registration" },
  ]},
  { parent: "fee", label: "Fee", children: [
    { code: "fee.search", label: "Search" },
    { code: "fee.adhoc", label: "ADHOC Fees" },
    { code: "fee.ledger", label: "Fee Ledger" },
    { code: "fee.student_fee", label: "Student Fee" },
    { code: "fee.structure", label: "Fee Structure" },
    { code: "fee.report", label: "Fee Report" },
  ]},
  { parent: "library", label: "Library", children: [
    { code: "library.library_dashboard", label: "Library Dashboard" },
    { code: "library.dashboard", label: "Book Dashboard" },
    { code: "library.category", label: "Book Category" },
    { code: "library.search", label: "Search" },
    { code: "library.configurations", label: "Book Configurations" },
    { code: "library.movements", label: "Issue/Return" },
    { code: "library.barcode", label: "Book Barcode" },
    { code: "library.title_report", label: "Book Title Report" },
    { code: "library.journal_report", label: "Journal Report" },
    { code: "library.accession_report", label: "Book Accession Report" },
    { code: "library.issue_return_report", label: "Issue/Return Report" },
    { code: "library.damaged_report", label: "Lost/Damaged Report" },
    { code: "library.most_circulated", label: "Most Circulated Book Report" },
  ]},
  { parent: "exam_results", label: "Exam Results", children: [
    { code: "exam_results.result", label: "Result" },
  ]},
  { parent: "transport", label: "Transport", children: [
    { code: "transport.dashboard", label: "Transport Dashboard" },
    { code: "transport.search", label: "Search" },
    { code: "transport.student_fee", label: "Student Transport Fee" },
  ]},
  { parent: "expense", label: "Expense", children: [
    { code: "expense.search", label: "Search Expense" },
    { code: "expense.category", label: "Expense/Income Category" },
    { code: "expense.party_master", label: "Party Master" },
    { code: "expense.ledger", label: "Expense Ledger" },
    { code: "expense.profit_loss", label: "Profit & Loss" },
    { code: "expense.day_book", label: "Day Book" },
  ]},
  { parent: "other_income", label: "Other Income", children: [
    { code: "other_income.search", label: "Search Income" },
  ]},
  { parent: "hostel", label: "Hostel", children: [
    { code: "hostel.dashboard", label: "Hostel Dashboard" },
    { code: "hostel.search", label: "Search" },
    { code: "hostel.student_details", label: "Student Hostel Details" },
    { code: "hostel.student_fee", label: "Student Hostel Fee" },
  ]},
  { parent: "timetable", label: "TimeTable", children: [
    { code: "timetable.class", label: "Class TimeTable" },
    { code: "timetable.teacher", label: "Teacher TimeTable" },
  ]},
  { parent: "lessonplan", label: "Lesson Plan", children: [
    { code: "lessonplan.lesson_plan", label: "Lesson Plan" },
    { code: "lessonplan.teacher", label: "Teacher Lesson Plan" },
    { code: "lessonplan.completion_report", label: "Lesson Plan Completion Report" },
  ]},
  { parent: "mentor", label: "Mentor", children: [
    { code: "mentor.assign", label: "Assign Mentor" },
    { code: "mentor.follow_ups", label: "Follow Ups" },
    { code: "mentor.student_details", label: "Student Details" },
  ]},
  { parent: "academics", label: "Academics", children: [
    { code: "academics.document_upload", label: "Document Upload" },
  ]},
  { parent: "grievance", label: "Grievance", children: [
    { code: "grievance.student", label: "Student Grievances" },
  ]},
  { parent: "visitors", label: "Visitors", children: [
    { code: "visitors.list", label: "Visitors List" },
  ]},
  { parent: "mou", label: "MOU", children: [
    { code: "mou.list", label: "MOU List" },
  ]},
  { parent: "training_placements", label: "Training and Placements", children: [
    { code: "training_placements.training", label: "Training" },
  ]},
  { parent: "inventory", label: "Inventory Management", children: [
    { code: "inventory.category", label: "Inventory Category" },
    { code: "inventory.search", label: "Inventory Search" },
  ]},
  { parent: "role", label: "Role", children: [
    { code: "role.create_admin_user", label: "Create New Role" },
    { code: "role.change_password", label: "Change Password", disabled: true },
  ]},
];


const CreateNewRoleForm = () => {
  const navigate = useNavigate();
  const [staffList, setStaffList] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({ roleName: "", userName: "", password: "", confirmPassword: "", linkedStaff: null });
  const [selectedModules, setSelectedModules] = useState(["role.change_password"]);
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [expandedParents, setExpandedParents] = useState({});

  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    fetchStaffList();
  }, []);

  const fetchStaffList = async () => {
    try {
      const res = await fetch(
        `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`,
        { headers: { Authorization: `Bearer ${accessToken}` } }
      );
      if (res.ok) {
        const result = await res.json();
        if (result.data) {
          setStaffList(
            result.data
              .filter((s) => {
                const t = String(s.employee_type || "").toLowerCase().replace(/-/g, " ").trim();
                return t === "non teaching staff" || t === "non teaching";
              })
              .map((s) => ({ value: s.id, label: s.employeeName }))
          );
        }
      }
    } catch (err) { console.error("Error fetching staff:", err); }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    if (errors[name]) setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleParentToggle = (parentModule) => {
    const selectableChildren = parentModule.children.filter((c) => !c.disabled).map((c) => c.code);
    const allSelected = selectableChildren.every((code) => selectedModules.includes(code));
    setSelectedModules((prev) =>
      allSelected
        ? prev.filter((code) => !selectableChildren.includes(code))
        : [...prev, ...selectableChildren.filter((code) => !prev.includes(code))]
    );
    if (errors.modules) setErrors((prev) => ({ ...prev, modules: "" }));
  };

  const handleChildToggle = (parentModule, childCode) => {
    const child = parentModule.children.find((c) => c.code === childCode);
    if (child && child.disabled) return;
    setSelectedModules((prev) =>
      prev.includes(childCode) ? prev.filter((c) => c !== childCode) : [...prev, childCode]
    );
    if (errors.modules) setErrors((prev) => ({ ...prev, modules: "" }));
  };

  const isParentFullySelected = (p) => p.children.every((c) => selectedModules.includes(c.code));
  const isParentPartiallySelected = (p) => {
    const selectable = p.children.filter((c) => !c.disabled).map((c) => c.code);
    const count = selectable.filter((c) => selectedModules.includes(c)).length;
    return count > 0 && count < selectable.length;
  };
  const getSelectedCount = (p) => p.children.filter((c) => selectedModules.includes(c.code)).length;
  const toggleParentExpansion = (code) => setExpandedParents((prev) => ({ ...prev, [code]: !prev[code] }));

  const handleSelectAll = () => {
    const allSelectable = moduleHierarchy.flatMap((p) => p.children.filter((c) => !c.disabled).map((c) => c.code));
    const disabled = moduleHierarchy.flatMap((p) => p.children.filter((c) => c.disabled).map((c) => c.code));
    const allSelected = allSelectable.every((c) => selectedModules.includes(c));
    setSelectedModules(allSelected ? disabled : [...allSelectable, ...disabled]);
  };

  const getTotalModuleCount = () => moduleHierarchy.reduce((sum, p) => sum + p.children.length, 0);

  const validateForm = () => {
    const newErrors = {};
    if (!formData.roleName.trim()) newErrors.roleName = "Role Name is required";
    if (!formData.userName.trim()) newErrors.userName = "Username is required";
    else if (formData.userName.length < 3) newErrors.userName = "Username must be at least 3 characters";
    if (!formData.password) newErrors.password = "Password is required";
    else if (formData.password.length < 6) newErrors.password = "Password must be at least 6 characters";
    if (!formData.confirmPassword) newErrors.confirmPassword = "Please confirm password";
    else if (formData.password !== formData.confirmPassword) newErrors.confirmPassword = "Passwords do not match";
    if (!formData.linkedStaff) newErrors.linkedStaff = "Staff is required";
    if (selectedModules.length === 0) newErrors.modules = "Please select at least one module";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSave = async () => {
    if (!validateForm()) return;
    setLoading(true);
    setSuccessMessage("");
    setErrorMessage("");
    try {
      const res = await fetch(`${ApiUrl.apiurl}AdminUser/Create/`, {
        method: "POST",
        headers: { "Content-Type": "application/json", Authorization: `Bearer ${accessToken}` },
        body: JSON.stringify({
          user_name: formData.userName,
          password: formData.password,
          role_name: formData.roleName,
          organization_id: parseInt(orgId),
          branch_id: parseInt(branchId),
          reference_id: formData.linkedStaff ? formData.linkedStaff.value : null,
          accessible_modules: selectedModules,
        }),
      });
      const result = await res.json();
      if (res.ok || result.message?.toLowerCase().includes("success")) {
        setSuccessMessage("Admin user created successfully!");
        setTimeout(() => navigate("/admin/create-new-role"), 2000);
      } else {
        setErrorMessage(result.message || "Failed to create admin user");
      }
    } catch (err) {
      setErrorMessage("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const handleClear = () => {
    setFormData({ roleName: "", userName: "", password: "", confirmPassword: "", linkedStaff: null });
    setSelectedModules(["role.change_password"]);
    setErrors({});
    setSuccessMessage("");
    setErrorMessage("");
  };

  const handleClose = () => navigate("/admin/create-new-role");

  const half = Math.ceil(moduleHierarchy.length / 2);

  const renderModuleColumn = (modules) =>
    modules.map((pm) => {
      const isExpanded = expandedParents[pm.parent];
      return (
        <div key={pm.parent} className="mb-2" style={{ border: "1px solid #dee2e6", borderRadius: "6px", padding: "8px 12px", backgroundColor: isExpanded ? "#f8f9fa" : "#fff" }}>
          <div className="d-flex align-items-center">
            <input
              className="form-check-input me-2"
              type="checkbox"
              id={`parent-${pm.parent}`}
              checked={isParentFullySelected(pm)}
              ref={(el) => { if (el) el.indeterminate = isParentPartiallySelected(pm); }}
              onChange={() => handleParentToggle(pm)}
            />
            <label
              className="form-check-label fw-bold flex-grow-1 mb-0 d-flex align-items-center"
              htmlFor={`parent-${pm.parent}`}
              style={{ cursor: "pointer" }}
            >
              <span onClick={(e) => { e.preventDefault(); toggleParentExpansion(pm.parent); }} className="me-1">
                {isExpanded ? <BsChevronDown size={12} /> : <BsChevronRight size={12} />}
              </span>
              {pm.label}
              <span className="badge bg-secondary ms-2" style={{ fontSize: "11px" }}>
                {getSelectedCount(pm)}/{pm.children.length}
              </span>
            </label>
          </div>
          {isExpanded && (
            <div className="row ms-3 mt-1">
              {pm.children.map((child) => (
                <div key={child.code} className="col-6 mb-1">
                  <div className="form-check">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      id={`child-${child.code}`}
                      checked={selectedModules.includes(child.code)}
                      onChange={() => handleChildToggle(pm, child.code)}
                      disabled={child.disabled || false}
                    />
                    <label className="form-check-label small" htmlFor={`child-${child.code}`}>
                      {child.label}{child.disabled && <span className="text-muted ms-1">(always on)</span>}
                    </label>
                  </div>
                </div>
              ))}
            </div>
          )}
        </div>
      );
    });

  return (
    <div className="container-fluid ">
      <div className="row">
        <div className="col-12">
          <div className="card p-0 ">
            <div className="card-body ">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                CREATE NEW USER ROLE
              </p>

              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                    disabled={loading}
                  >
                    {loading ? "Saving..." : "Save"}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={handleClose}
                  >
                    Close
                  </button>
                </div>
              </div>

              {successMessage && (
                <div className="alert alert-success alert-dismissible">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setSuccessMessage("")}
                  ></button>
                  {successMessage}
                </div>
              )}
              {errorMessage && (
                <div className="alert alert-danger alert-dismissible">
                  <button
                    type="button"
                    className="btn-close"
                    onClick={() => setErrorMessage("")}
                  ></button>
                  {errorMessage}
                </div>
              )}

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1 mt-3">
                      <div className="col-12 col-md-6">
                        <div >
                          <div className="mb-3">
                            <label className="form-label fw-bold">
                              Role Name <span className="text-danger">*</span>
                            </label>
                            <input
                              type="text"
                              className={`form-control ${errors.roleName ? "is-invalid" : ""}`}
                              name="roleName"
                              value={formData.roleName}
                              onChange={handleInputChange}
                              placeholder="e.g. Fee Manager, HR Admin"
                            />
                            {errors.roleName && (
                              <div className="invalid-feedback">
                                {errors.roleName}
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Username <span className="text-danger">*</span>
                          </label>
                          <input
                            type="text"
                            className={`form-control ${errors.userName ? "is-invalid" : ""}`}
                            name="userName"
                            value={formData.userName}
                            onChange={handleInputChange}
                            placeholder="Min 3 characters"
                            autoComplete="off"
                          />
                          {errors.userName && (
                            <div className="invalid-feedback">
                              {errors.userName}
                            </div>
                          )}
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Non Teaching Staff{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <Select
                            options={staffList}
                            value={formData.linkedStaff}
                            onChange={(v) => {
                              setFormData((p) => ({ ...p, linkedStaff: v }));
                              if (errors.linkedStaff)
                                setErrors((p) => ({ ...p, linkedStaff: "" }));
                            }}
                            placeholder="Select Staff"
                            isClearable
                            className={errors.linkedStaff ? "is-invalid" : ""}
                          />
                          {errors.linkedStaff && (
                            <div className="text-danger small mt-1">
                              {errors.linkedStaff}
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-12 col-md-6">
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Password <span className="text-danger">*</span>
                          </label>
                          <InputGroup hasValidation>
                            <input
                              type={showPassword ? "text" : "password"}
                              className={`form-control ${errors.password ? "is-invalid" : ""}`}
                              name="password"
                              value={formData.password}
                              onChange={handleInputChange}
                              placeholder="Min 6 characters"
                              autoComplete="new-password"
                            />
                            <InputGroup.Text
                              style={{ cursor: "pointer" }}
                              onClick={() => setShowPassword(!showPassword)}
                            >
                              {showPassword ? (
                                <BsEyeSlash size={18} />
                              ) : (
                                <BsEye size={18} />
                              )}
                            </InputGroup.Text>
                            {errors.password && (
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                {errors.password}
                              </div>
                            )}
                          </InputGroup>
                        </div>
                        <div className="mb-3">
                          <label className="form-label fw-bold">
                            Confirm Password{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <InputGroup hasValidation>
                            <input
                              type={showConfirmPassword ? "text" : "password"}
                              className={`form-control ${errors.confirmPassword ? "is-invalid" : ""}`}
                              name="confirmPassword"
                              value={formData.confirmPassword}
                              onChange={handleInputChange}
                              placeholder="Re-enter password"
                              autoComplete="new-password"
                            />
                            <InputGroup.Text
                              style={{ cursor: "pointer" }}
                              onClick={() =>
                                setShowConfirmPassword(!showConfirmPassword)
                              }
                            >
                              {showConfirmPassword ? (
                                <BsEyeSlash size={18} />
                              ) : (
                                <BsEye size={18} />
                              )}
                            </InputGroup.Text>
                            {errors.confirmPassword && (
                              <div
                                className="invalid-feedback"
                                style={{ display: "block" }}
                              >
                                {errors.confirmPassword}
                              </div>
                            )}
                          </InputGroup>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex justify-content-between align-items-center mb-2 mt-4">
                <h6 className="mb-0 fw-bold">Module Access Permissions</h6>
                <div className="d-flex align-items-center gap-3">
                  <button
                    type="button"
                    className="btn btn-sm btn-outline-primary"
                    onClick={handleSelectAll}
                  >
                    {moduleHierarchy
                      .flatMap((p) =>
                        p.children
                          .filter((c) => !c.disabled)
                          .map((c) => c.code),
                      )
                      .every((c) => selectedModules.includes(c))
                      ? "Deselect All"
                      : "Select All"}
                  </button>
                  <span className="badge bg-primary">
                    {selectedModules.length} of {getTotalModuleCount()} selected
                  </span>
                </div>
              </div>
              {errors.modules && (
                <div className="alert alert-danger py-2">{errors.modules}</div>
              )}
              <p className="text-muted small mb-3">
                Click on a module name to expand and select sub-permissions.
              </p>

              <div className="row">
                <div
                  className="col-md-6"
                  style={{
                    borderRight: "2px solid #dee2e6",
                    paddingRight: "20px",
                  }}
                >
                  {renderModuleColumn(moduleHierarchy.slice(0, half))}
                </div>
                <div className="col-md-6" style={{ paddingLeft: "20px" }}>
                  {renderModuleColumn(moduleHierarchy.slice(half))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CreateNewRoleForm;
